import BaseContainer from "@base/container/BaseContainer";
import {Signals} from "@/Imports";
import TweenMax from "gsap";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import gsap from "gsap";
import Facade from "@/Facade";

export default class FeatureContainer extends BaseContainer {

  constructor(data) {
    super(data)

    this.startX = 120
    this.startY = 140

    this.init()
  }

  init(data) {
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)
    Signals.startFeature.add(this.onStart, this)
    Signals.stopFeature.add(this.onStop, this)

    this.attack = new SpineAnimation('bossAttack')
    this.attack.position.set(-120, 150)
    this.attack.alpha = 0
    this.addChild(this.attack)

    this.enemy = new SpineAnimation('boss')
    this.enemy.scale.set(0.75)
    this.enemy.position.set(this.startX, this.startY)
    this.enemy.alpha = 0
    this.addChild(this.enemy)

    this.isFeatureStopped = true
  }

  onStart() {
    /*
    snowman
      attackIn
      attackLoop
      attackOut

      death
      escape
      idle
      intro

    attack:
      bossAttackIn
      bossAttackLoop
      bossDeath
      bossWin
     */
    this.realStartFeatureTimer = setTimeout(() => {
      this._onStart()
    }, Facade.model.randomTime)
  }

  _onStart() {
    this.show()
  }

  onRoundEnd() {
    clearTimeout(this.realStartFeatureTimer)
    clearTimeout(this.shootingTimeout)

    if (this.isFeatureStopped) {
      return
    }

    this.hide()
  }

  onMakeBets() {
    this.hide()
  }

  onStop(currentBonus) {
    clearTimeout(this.realStartFeatureTimer)
    this.realStartFeatureTimer = null

    if (this.isFeatureStopped)
      return

    let animation = 'death'

    if (currentBonus.tp === "multiplier" && currentBonus.v === 1) {
      animation = 'escape'
    }

    this.hide(animation)
  }

  show() {
    this.isFeatureStopped = false

    TweenMax.killTweensOf(this.enemy)
    TweenMax.to(this.enemy.position, 0.5, {x: this.startX, y: this.startY})
    TweenMax.to(this.enemy, 0.5, {alpha: 1})
    TweenMax.to(this.attack, 1, {alpha: 1})

    Facade.soundManager.play('bossIntroSound', 0.8)
    this.enemy.start(['intro', 'idle'], [false, true])

    this.shootingTimeout = setTimeout(() => {
      this.shooting()
    }, 1500)
  }

  hide(finalAnimation) {
    Facade.soundManager.stop('bossAttackSound')

    if (!finalAnimation)
      finalAnimation = 'escape'

    if (!this.isFeatureStopped) {
      if (finalAnimation === 'escape') {
        Facade.soundManager.play('bossEscapeSound', 0.2)
        this.attack.start(['bossDeath'], [false])
      } else {
        Facade.soundManager.play('bossDeathSound', 0.2)
        this.attack.start(['bossWin'], [false])
      }
    }

    this.isFeatureStopped = true
    this.enemy.start([finalAnimation], [false])


    TweenMax.killTweensOf(this.enemy)
    TweenMax.to(this.enemy.position, 1, {x: 0, y: 0})
    TweenMax.to(this.enemy, 1, {alpha: 0})
    TweenMax.to(this.attack, 1, {alpha: 0})
  }

  shooting() {
    /*
    snowman
      attackIn
      attackLoop
      attackOut

      death
      escape
      idle
      intro

    attack:
      bossAttackIn
      bossAttackLoop
      bossDeath
      bossWin
     */

    Facade.soundManager.play('bossAttackSound', 0.4, true)

    this.attack.start(['bossAttackIn', 'bossAttackLoop'], [false, true])
    this.enemy.start(['attackIn', 'attackLoop'], [false, true])
  }

}
